import * as angular from 'angular';

"use strict";
angular.module('ManagerService', []);

export default 'ManagerService'